<template>
  <v-row>
    <v-col cols="12" md="4" align="stretch" height="auto">
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0"
        align="stretch"
        height="auto"
      >
        <v-card-title dense>
          CES Índice de Esfuerzo de Cliente
        </v-card-title>

        <v-row align="stretch">
          <v-col cols="12">
            <v-simple-table light dense>
              <template v-slot:default>
                <thead style="background-color: #3fa9be; color: white;">
                  <tr>
                    <th
                      class="text-center"
                      style="width: 50%;color: white !important;"
                    >
                      Indice
                    </th>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <th
                          class="text-center"
                          v-on="on"
                          style="color: white !important;"
                        >
                          Respuestas
                          <v-icon color="white" dense>mdi-help-circle</v-icon>
                        </th>
                      </template>
                      <span>
                        En esta columna ingresá la cantidad de respuestas
                        <br />que se tiene con cada calificación.
                      </span>
                    </v-tooltip>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in datos_ces" :key="item.id">
                    <td class="ma-0 pa-0 text-center">{{ item.titulo }}</td>
                    <td
                      class="ma-0 pa-0 text-center"
                      @click="mostrarInput(index, 1)"
                    >
                      <span
                        v-show="celda_activa != 'f' + index + 'c1'"
                        @click="mostrarInput(index, 1)"
                        style="width: 100%"
                        >{{ item.cant_encuestas | numero }}</span
                      >
                      <input
                        type="text"
                        class="campo text-center"
                        v-show="celda_activa == 'f' + index + 'c1'"
                        :ref="'f' + index + 'c1'"
                        v-model="datos_ces[index].cant_encuestas"
                        @keydown.tab.stop.prevent="finEdicionDown(index, 1)"
                        @keyup.arrow-up.arrow-left="finEdicionUp(index, 1)"
                        @keyup.arrow-down.enter.arrow-right="
                          finEdicionDown(index, 1)
                        "
                        @keyup.esc="escape('f' + index + 'c1')"
                        @keypress="esNumero($event)"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="ma-0 pa-0 text-center">TOTAL</td>
                    <td class="ma-0 pa-0 text-center">{{ total_encuestas }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col align-self="center">
            <v-card>
              <p class="text-center display-1" style="width: 100%;">
                CES: {{ (calculaCes().toFixed(2) + '').replace('.', ',') }}
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        color="#f4f4f4"
        class="pa-1 ma-1 mt-0 caption"
        align="stretch"
        height="auto"
      >
        Si querés saber más sobre lo que hacemos en BleCX y cómo podemos
        ayudarte con tu negocio o empresa contactate con nosotros
        <a
          href="http://www.blecx.com.ar/#contacto"
          target="_blank"
          rel="noopener noreferrer"
          aria-current="page"
          >aquí</a
        >
      </v-card>
    </v-col>
    <v-col cols="12" md="8">
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mt-0">
        <v-card-title class="headline">¿Qué es CES?</v-card-title>
        <v-card-subtitle class="text-justify"
          >El índice de esfuerzo del cliente (CES: Customer Effort Score) es una
          métrica que indica cuánto esfuerzo se requirió por parte de los
          clientes para resolver un problema y/o encontrar la información que
          estaban buscando. Un CES bajo puede sugerir que los clientes se tomen
          demasiado tiempo para encontrar los recursos que necesitan, lo que
          indica que tu empresa puede necesitar mejoras en el acceso a la
          información para los clientes y en la resolución de
          problemas.</v-card-subtitle
        >
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mt-0">
        <v-card-title class="headline"
          >¿Cómo se obtienen los datos?</v-card-title
        >
        <v-card-subtitle class="text-justify"
          >Podés realizar encuestas CES, luego de las llamadas realizadas a
          atención al cliente, en los chatbots o en los correos electrónicos de
          soporte al cliente.</v-card-subtitle
        >
      </v-card>
      <v-card color="#f4f4f4" height="auto" class="pa-1 ma-1 mb-2">
        <v-card-title class="headline">¿Cómo se calcula?</v-card-title>
        <v-card-subtitle class="text-justify"
          >CES = promedio simple de todas las calificaciones de la escala
          utilizada</v-card-subtitle
        >
        <v-card-text>
          <a
            href="https://www.blecx.com.ar/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-img
              src="../assets/logo.svg"
              width="80"
              align="bottom"
              class="ml-auto"
            ></v-img>
          </a>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      celda_activa: '',
      datos_ces: [
        { titulo: 'Muy Difícil', cant_encuestas: null },
        { titulo: 'Difícil', cant_encuestas: null },
        { titulo: 'Neutro', cant_encuestas: null },
        { titulo: 'Simple', cant_encuestas: null },
        { titulo: 'Muy Simple', cant_encuestas: null },
      ],
    };
  },
  filters: {
    numero: function(value) {
      value = parseInt(value);
      if (!isFinite(value) || (!value && value !== 0)) return '';
      return value;
    },
    porcentaje(val) {
      return ((val * 100).toFixed(2) + '%').replace('.', ',');
    },
  },

  methods: {
    calculaCes: function() {
      var suma = 0;
      var resultado = 0;
      var valor = 0;
      for (var i = 0; i < 5; i++) {
        valor = parseInt(this.datos_ces[i].cant_encuestas);
        if (!isFinite(valor) || (!valor && valor !== 0)) valor = 0;
        suma += valor * (i + 1);
      }
      resultado = suma / this.total_encuestas;
      if (!isFinite(resultado) || (!resultado && resultado !== 0))
        resultado = 0;
      return resultado;
    },
    mostrarInput(fila, columna) {
      var referencia = `f${fila}c${columna}`;
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    finEdicionUp(fila, columna) {
      var prox_fila = fila > 0 ? fila - 1 : 0;
      var referencia = `f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicionDown(fila, columna) {
      var prox_fila = fila < 4 ? fila + 1 : 4;
      var referencia = `f${prox_fila}c${columna}`;
      this.finEdicion(referencia);
    },
    finEdicion(referencia) {
      this.celda_activa = referencia;
      this.$nextTick(() => {
        this.$refs[referencia][0].focus();
      });
    },
    escape(referencia) {
      this.celda_activa = '';
      this.$nextTick(() => {
        this.$refs[referencia][0].blur();
      });
    },
    esNumero(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
  computed: {
    total_encuestas: function() {
      var total_encuestas = 0;
      var valor = 0;
      for (let item of this.datos_ces) {
        valor = parseInt(item.cant_encuestas);
        if (!isFinite(valor) || (!valor && valor !== 0)) valor = 0;
        total_encuestas += valor;
      }
      return total_encuestas;
    },
  },
};
</script>

<style>
.activa {
  background-color: #eaf0f6;
}
.campo {
  width: 100%;
}
.v-card__text,
.v-card__title {
  word-break: normal; /* maybe !important  */
} /* solución a los títulos de vcard que se cortan las palabras a la mitad */
</style>
